import { Component, OnInit, OnChanges, Input, SimpleChanges } from '@angular/core';
import { DynamicFieldsService } from '../dynamic-fields.service';

@Component({
    selector: 'dynfield-date',
    template: require('./dynamic-fields.date.component.html')
})
export class DynamicFieldDateComponent implements OnInit, OnChanges {
    @Input() version: any;
    @Input() field: any;
    @Input() fieldError: any;
    @Input() allowUpdate: any;

    isRequired: boolean;
    error: any;

    constructor(private dynamicFieldsService: DynamicFieldsService) {}

    ngOnInit() {
        this.error = this.dynamicFieldsService.setError(this.fieldError, this.field);
        this.isRequired = this.dynamicFieldsService.isRequired(this);
    }

    ngOnChanges(changes: SimpleChanges) {
        if(changes.fieldError) {
            this.error = this.dynamicFieldsService.setError(
                changes.fieldError?.currentValue, this.field
            );
        }
    }

    onUpdate(date: string) {
        this.field.fieldData = date;
    }
}
